import { render, staticRenderFns } from "./SelectBooleanComponent.vue?vue&type=template&id=3b5eadc6&scoped=true"
import script from "./SelectBooleanComponent.vue?vue&type=script&lang=js"
export * from "./SelectBooleanComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5eadc6",
  null
  
)

export default component.exports